import './RegisterPage.css'
import RegisterPageForm from '../../features/RegisterPage/RegisterPageForm/RegisterPageForm'
import DecorativeEmptyCircle from '../../components/DecorativeEmptyCircle/DecorativeEmptyCircle'
import { useConfigContext } from '../../contexts/ConfigContext/ConfigContextProvider'

export default function RegisterPage() {

   const { jsonBranding, jsonFeatures } = useConfigContext()
   const { showDecorativeCircle } = jsonFeatures?.pages
   const logo = jsonBranding?.logo
   return (
      <section className='RegisterPage-container'>

         <div className='RegisterPage-content'>

            {showDecorativeCircle && <>
               < DecorativeEmptyCircle size={200} opacity={.2} bottom={-50} right={-50} color='var(--color-secondary)' borderWidth={32} />
               < DecorativeEmptyCircle size={180} opacity={.2} top={-50} left={-50} color='var(--color-secondary)' borderWidth={32} />
               < DecorativeEmptyCircle size={100} opacity={.2} top={220} left={100} color='var(--color-secondary)' borderWidth={16} />
               < DecorativeEmptyCircle size={100} opacity={.1} top={50} right={40} color='var(--color-secondary)' borderWidth={16} />
            </>}

            <div className='RegisterPage-up-container'>
               < img src={logo} alt='logo' />
               <h3 className='RegisterPage-left-title'>
                  Vamos a terminar tu registro
               </h3>
            </div>
            < RegisterPageForm />
         </div>

      </section>
   )
}
